export const formatTimestampRes = (data) => {
  return {
    targetDate: data.parseDate(),
    targetTime: data.parseTime(),
    id: data.id,
    description: data.getTimestampDescription(),
    timestampTypeId: data.timestampTypeId,
    targetDateTime: data.targetDateTime,
  };
}